import React from "react";

const AddDataModal = ({
  onClose,
  onUploadClick,
  onFileSelected,
  onManualEntry,
  fileInputRef,
}) => {
  return (
    <div className="p-3">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="m-0 fw-bold">Choose How to Add Data</h5>
        <button className="btn-close" aria-label="Close" onClick={onClose} />
      </div>
      <hr />
      <p className="mb-4">Select your preferred method below to continue.</p>

      <div className="d-flex justify-content-center gap-2">
        <button
          className="btn"
          style={{ backgroundColor: "#d1d1d1", color: "black" }}
          onClick={onUploadClick}
        >
          <i class="bi bi-filetype-xlsx"></i> Upload .CSV / .XLSX
        </button>

        {/* Hidden input for file selection */}
        <input
          ref={fileInputRef}
          type="file"
          accept=".csv,.xlsx,.xls"
          style={{ display: "none" }}
          onChange={onFileSelected}
        />

        {/* <button
          className="btn text-white"
          style={{ backgroundColor: "#82c14a" }}
          onClick={onManualEntry}
        >
          <i class="bi bi-plus-circle"></i> Manual Entry
        </button> */}
      </div>
    </div>
  );
};

export default AddDataModal;
